import { ExternalLink } from 'lucide-react';
import {
  ProductCarouselData,
  ProductCarouselProduct,
} from '@/Domain/api/Conversation/dto/Message.dto';

type Props = {
  data: ProductCarouselData;
};

const ProductCard = ({ product }: { product: ProductCarouselProduct }) => (
  <a
    href={product.url}
    target="_blank"
    rel="noopener noreferrer"
    className="group flex-shrink-0 w-[160px] overflow-hidden rounded-lg border border-border bg-card transition-shadow hover:shadow-md"
    data-testid="inbox-product-card"
  >
    <div className="relative aspect-square w-full overflow-hidden bg-muted">
      <img
        src={product.image_url}
        alt={product.product_name}
        className="h-full w-full object-cover transition-transform group-hover:scale-105"
        loading="lazy"
      />
    </div>
    <div className="flex flex-col gap-1 p-2.5">
      <div className="flex items-start justify-between gap-1.5">
        <h3 className="text-sm font-medium leading-tight text-foreground line-clamp-2">
          {product.product_name}
        </h3>
        <ExternalLink className="mt-0.5 h-3 w-3 shrink-0 text-foreground-subtle opacity-0 transition-opacity group-hover:opacity-100" />
      </div>
      <p className="text-sm font-semibold text-foreground">{product.price}</p>
      {product.description && (
        <p className="text-xs leading-relaxed text-foreground-subtle line-clamp-2">
          {product.description}
        </p>
      )}
    </div>
  </a>
);

export const InboxProductCarousel = ({ data }: Props) => {
  const { products } = data;

  if (!products || products.length === 0) return null;

  return (
    <div
      className="flex gap-2 overflow-x-auto py-1 scrollbar-thin"
      data-testid="inbox-product-carousel"
    >
      {products.map((product) => (
        <ProductCard key={product.url} product={product} />
      ))}
    </div>
  );
};
